import { SearchBold } from '@tencent/odc-iconpack';
import React, { forwardRef } from 'react';

import './index.scss';

const HelpCenterBanner = (props: {
  onSearchClick?: () => void;
  style: React.CSSProperties;
}, ref: React.ForwardedRef<HTMLDivElement>) => {
  const { onSearchClick, style } = props;
  return (
    <div
      className="odc-help-center-banner"
      style={style}
      ref={ref}
    >
      <div className="help-center-title">How can we help you today?</div>
      <div className="help-center-search" onClick={onSearchClick}>
        <div className="help-center-search-bar">
          <div className="help-center-search-icon">
            <SearchBold />
          </div>
          <div className="help-center-search-placeholder">Search by topic or keyword</div>
        </div>
      </div>
    </div>
  );
};

export default forwardRef(HelpCenterBanner);